export interface ITranslateModel {
  languageCode: string;
  fieldName: string;
  translatedValue: string;
}

export interface IMultilingualConfig {
  fieldNames: string[];
  supportedLanguages: ILanguageOption[];
  defaultLanguage: string;
}

export interface ILanguageOption {
  code: string;
  name: string;
  flag?: string;
}

// Custom language set for categories (fr, en, it, de)
export const CATEGORY_LANGUAGES: ILanguageOption[] = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'fr', name: 'French', flag: '🇫🇷' },
  { code: 'de', name: 'German', flag: '🇩🇪' },
  { code: 'it', name: 'Italian', flag: '🇮🇹' },
];
